import React from 'react';
import classNames from '../libs/utils/classNames';

interface InlineBadgeProps {
  label: string;
  color?: string;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'solid' | 'outline';
}

const InlineBadge: React.FC<InlineBadgeProps> = ({
  label,
  color = 'gray',
  size = 'md',
  variant = 'solid',
}) => {
  const colorClasses = {
    solid: {
      green: 'bg-green-600 text-white',
      red: 'bg-red-700 text-white',
      yellow: 'bg-yellow-500 text-white',
      orange: 'bg-orange-500 text-white',
      teal: 'bg-teal-600 text-white',
      gray: 'bg-gray-200 text-gray-500',
    },
    outline: {
      green: 'border border-green-600 text-green-600 bg-transparent',
      red: 'border border-red-700 text-red-700 bg-transparent',
      yellow: 'border border-yellow-500 text-yellow-500 bg-transparent',
      orange: 'border border-orange-500 text-orange-500 bg-transparent',
      teal: 'border border-teal-600 text-teal-600 bg-transparent',
      gray: 'border border-gray-200 text-gray-800 bg-neutral-50',
    },
  };

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm',
    lg: 'px-4 py-1.5 text-base',
  };

  return (
    <span
      className={classNames(
        'inline-flex items-center justify-center rounded-full font-medium',
        sizeClasses[size],
        colorClasses[variant][color as keyof typeof colorClasses.solid] ||
          colorClasses[variant].gray
      )}
    >
      {label}
    </span>
  );
};

export default InlineBadge;
